'use client';

import { createBox } from '@mui/system';
import { unstable_ClassNameGenerator as ClassNameGenerator } from "../className/index.js";
import { createTheme } from "../styles/index.js";
import THEME_ID from "../styles/identifier.js";
import boxClasses from "./boxClasses.js";
var defaultTheme = createTheme();
var Box = createBox({
  themeId: THEME_ID,
  defaultTheme: defaultTheme,
  defaultClassName: boxClasses.root,
  generateClassName: ClassNameGenerator.generate
});
process.env.NODE_ENV !== "production" ? void 0 : void 0;
export default Box;